import { emailPattern } from '../appconfig/Settings';

export const LoginValidate = (inputDetail: any) => {
    let isError: boolean = false;

    let errorObj: any = {};

    let errors: any = {};

    if (window.cn(inputDetail.mobile) && !window.cb(inputDetail.mobile)) {
        errors = { ...errors, mobile: 'Please Enter Mobile Number *' };
        isError = true;
    } else if (inputDetail.mobile.toString().length > 10 || inputDetail.mobile.toString().length < 10) {
        errors = { ...errors, mobile: 'Mobile Number Should be 10 digits*' };
        isError = true;
    } else {
        errors = { ...errors, mobile: '' };
    }

    if (window.cn(inputDetail.password) && !window.cb(inputDetail.password)) {
        errors = { ...errors, password: 'Enter Password *' };
        isError = true;
    } else {
        errors = { ...errors, password: '' };
    }

    errorObj = { errors, isError };

    return errorObj;
};

export const ChangePasswordFormValidate = (inputDetail: any) => {
    //Define Errors Object / Validate
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    //Check Every Input Condition
    if (window.cn(inputDetail.old_password) && !window.cb(inputDetail.old_password)) {
        errors = { ...errors, old_password: 'Enter Old Password *' };
        isError = true;
    } else {
        errors = { ...errors, password: '' };
    }

    if (window.cn(inputDetail.password) && !window.cb(inputDetail.password)) {
        errors = { ...errors, password: 'Enter New Password *' };
        isError = true;
    } else {
        errors = { ...errors, password: '' };
    }

    if (window.cn(inputDetail.confirm_password) && !window.cb(inputDetail.confirm_password)) {
        errors = { ...errors, confirm_password: 'Enter Confirm Password *' };
        isError = true;
    } else if (inputDetail.password !== inputDetail.confirm_password) {
        errors = { ...errors, confirm_password: 'Confirm Password does not Match to Password*' };
        isError = true;
    } else {
        errors = { ...errors, confirm_password: '' };
    }

    //End Every Input Condition

    errorObj = { errors, isError };

    return errorObj;
};

// Add update category validate
export const AddUpdateCategoryValidate = (categoryName: any, categoryImage: any, categoryDesc: any) => {
    //Define Errors Object / Validate
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(categoryName) && !window.cb(categoryName)) {
        errors = { ...errors, category_name: 'Please Enter Category Name *' };
        isError = true;
    } else {
        errors = { ...errors, category_name: '' };
    }

    if (window.cn(categoryImage) && !window.cb(categoryImage)) {
        errors = { ...errors, category_img: 'Please Select Category Image *' };
        isError = true;
    } else {
        errors = { ...errors, category_img: '' };
    }

    if (window.cn(categoryDesc) && !window.cb(categoryDesc)) {
        errors = { ...errors, category_desc: 'Please Enter Category Description *' };
        isError = true;
    } else {
        errors = { ...errors, category_desc: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add update role name validate
export const AddUpdateRoleNameValidate = (roleName: any) => {
    //Define Errors Object / Validate
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(roleName) && !window.cb(roleName)) {
        errors = { ...errors, role_name: 'Please Enter Role Name *' };
        isError = true;
    } else {
        errors = { ...errors, role_name: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add Update User Validate
export const AddUpdateUserValidate = (userData: any, permissions: any) => {
    let isError: boolean = false;

    let errorObj: any = {};

    let errors: any = {};

    if (window.cn(userData.first_name) && !window.cb(userData.first_name)) {
        errors = { ...errors, first_name: 'Please Enter First Name *' };
        isError = true;
    } else {
        errors = { ...errors, first_name: '' };
    }

    if (window.cn(userData.last_name) && !window.cb(userData.last_name)) {
        errors = { ...errors, last_name: 'Please Enter Last Name *' };
        isError = true;
    } else {
        errors = { ...errors, last_name: '' };
    }

    if (window.cn(userData.mobile) && !window.cb(userData.mobile)) {
        errors = { ...errors, mobile: 'Please Enter Mobile Number *' };
        isError = true;
    } else if (userData.mobile.toString().length > 10 || userData.mobile.toString().length < 10) {
        errors = { ...errors, mobile: 'Mobile Number Should be 10 digits*' };
        isError = true;
    } else {
        errors = { ...errors, mobile: '' };
    }

    if (window.cn(userData.user_permission) && !window.cb(userData.user_permission)) {
        errors = { ...errors, user_permission: 'Please Select Atleast one permission  *' };
        isError = true;
    } else {
        errors = { ...errors, user_permission: '' };
    }

    errorObj = { errors, isError };

    return errorObj;
};

// Add update brand validate
export const AddUpdateBrandValidate = (brandName: any, brandImg: any) => {
    //Define Errors Object / Validate
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(brandName) && !window.cb(brandName)) {
        errors = { ...errors, brand_name: 'Please Enter Brand Name *' };
        isError = true;
    } else {
        errors = { ...errors, brand_name: '' };
    }

    if (window.cn(brandImg) && !window.cb(brandImg)) {
        errors = { ...errors, brand_img: 'Please Select Brand Image *' };
        isError = true;
    } else {
        errors = { ...errors, brand_img: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};

// Add update product validate
export const AddUpdateProductValidate = (productData: any, productDesc: any) => {
    //Define Errors Object / Validate
    let isError: boolean = false;
    let errorObj: any = {};
    let errors: any = {};

    if (window.cn(productData.product_name) && !window.cb(productData.product_name)) {
        errors = { ...errors, product_name: 'Please Enter Full Name *' };
        isError = true;
    } else {
        errors = { ...errors, product_name: '' };
    }

    if (window.cn(productData.brand_id) && !window.cb(productData.brand_id)) {
        errors = { ...errors, brand_id: 'Please Select Brand *' };
        isError = true;
    } else {
        errors = { ...errors, brand_id: '' };
    }

    if (window.cn(productData.category_id) && !window.cb(productData.category_id)) {
        errors = { ...errors, category_id: 'Please Select Category *' };
        isError = true;
    } else {
        errors = { ...errors, category_id: '' };
    }

    if (window.cn(productData.product_img) && !window.cb(productData.product_img)) {
        errors = { ...errors, product_img: 'Please Select Image *' };
        isError = true;
    } else {
        errors = { ...errors, product_img: '' };
    }

    if (window.cn(productDesc) && !window.cb(productDesc)) {
        errors = { ...errors, product_desc: 'Please Enter Product Description *' };
        isError = true;
    } else {
        errors = { ...errors, product_desc: '' };
    }

    errorObj = { errors, isError };
    return errorObj;
};
